import type { SelectServerOptions } from "../../Form.types";

export const useSelectFieldFallbackFilter = ({
  serverOptions,
  value,
}: {
  serverOptions?: SelectServerOptions;
  value: any;
}) => {
  if (serverOptions) {
    return {
      items: [
        {
          field: serverOptions.valueProp || "id",
          operator: "exact",
          value: value,
        },
      ],
    };
  }
  return undefined;
};
